const OPEN_MENU = 'scratch-gui/menus/OPEN_MENU';
const CLOSE_MENU = 'scratch-gui/menus/CLOSE_MENU';

const MENU_ABOUT = 'aboutMenu';
const MENU_ACCOUNT = 'accountMenu';
const MENU_FILE = 'fileMenu';
const MENU_EDIT = 'editMenu';
const MENU_LANGUAGE = 'languageMenu';
const MENU_LOGIN = 'loginMenu';
const MENU_SERIALPORT = 'serialportMenu';
const MENU_SETTING = 'setting';
// Phase 3 / Plan 03-09 (W-13) — Help dropdown menu state (PRJ-06 + PRJ-07).
// Mirrors the existing fileMenu / settingMenu pattern exactly.
const MENU_HELP = 'helpMenu';
// Phase 6 / Plan 06-01 — "Mở rộng" (Khối Mở rộng) authoring dropdown state.
// Mirrors the MENU_HELP pattern exactly (DR-05).
const MENU_EXT = 'extMenu';
// menu-bar-modernization — "Quản lý" consolidation dropdown state.
// Groups Robot Manager + Kit (SmartHome) Manager + Upload Firmware into a
// single top-level dropdown to de-clutter the header. Mirrors MENU_HELP /
// MENU_EXT exactly.
const MENU_MANAGE = 'manageMenu';


const initialState = {
    [MENU_ABOUT]: false,
    [MENU_ACCOUNT]: false,
    [MENU_FILE]: false,
    [MENU_EDIT]: false,
    [MENU_LANGUAGE]: false,
    [MENU_LOGIN]: false,
    [MENU_SERIALPORT]: false,
    [MENU_SETTING]: false,
    [MENU_HELP]: false,
    [MENU_EXT]: false,
    [MENU_MANAGE]: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case OPEN_MENU:
        return Object.assign({}, state, {
            [action.menu]: true
        });
    case CLOSE_MENU:
        return Object.assign({}, state, {
            [action.menu]: false
        });
    default:
        return state;
    }
};
const openMenu = menu => ({
    type: OPEN_MENU,
    menu: menu
});
const closeMenu = menu => ({
    type: CLOSE_MENU,
    menu: menu
});
const openAboutMenu = () => openMenu(MENU_ABOUT);
const closeAboutMenu = () => closeMenu(MENU_ABOUT);
const aboutMenuOpen = state => state.scratchGui.menus[MENU_ABOUT];
const openAccountMenu = () => openMenu(MENU_ACCOUNT);
const closeAccountMenu = () => closeMenu(MENU_ACCOUNT);
const accountMenuOpen = state => state.scratchGui.menus[MENU_ACCOUNT];
const openFileMenu = () => openMenu(MENU_FILE);
const closeFileMenu = () => closeMenu(MENU_FILE);
const fileMenuOpen = state => state.scratchGui.menus[MENU_FILE];
const openEditMenu = () => openMenu(MENU_EDIT);
const closeEditMenu = () => closeMenu(MENU_EDIT);
const editMenuOpen = state => state.scratchGui.menus[MENU_EDIT];
const openLanguageMenu = () => openMenu(MENU_LANGUAGE);
const closeLanguageMenu = () => closeMenu(MENU_LANGUAGE);
const languageMenuOpen = state => state.scratchGui.menus[MENU_LANGUAGE];
const openLoginMenu = () => openMenu(MENU_LOGIN);
const closeLoginMenu = () => closeMenu(MENU_LOGIN);
const loginMenuOpen = state => state.scratchGui.menus[MENU_LOGIN];
const openSerialportMenu = () => openMenu(MENU_LOGIN);
const closeSerialportMenu = () => closeMenu(MENU_LOGIN);
const serialportMenuOpen = state => state.scratchGui.menus[MENU_LOGIN];
const openSettingMenu = () => openMenu(MENU_SETTING);
const closeSettingMenu = () => closeMenu(MENU_SETTING);
const settingMenuOpen = state => state.scratchGui.menus[MENU_SETTING];
// Phase 3 / Plan 03-09 (W-13) — Help dropdown action creators + selector.
// Mirrors openFileMenu / closeFileMenu / fileMenuOpen exactly.
const openHelpMenu = () => openMenu(MENU_HELP);
const closeHelpMenu = () => closeMenu(MENU_HELP);
const helpMenuOpen = state => state.scratchGui.menus[MENU_HELP];
// Phase 6 / Plan 06-01 — "Mở rộng" dropdown action creators + selector.
// Mirrors openHelpMenu / closeHelpMenu / helpMenuOpen exactly.
const openExtMenu = () => openMenu(MENU_EXT);
const closeExtMenu = () => closeMenu(MENU_EXT);
const extMenuOpen = state => state.scratchGui.menus[MENU_EXT];
// menu-bar-modernization — "Quản lý" dropdown action creators + selector.
// Mirrors openExtMenu / closeExtMenu / extMenuOpen exactly.
const openManageMenu = () => openMenu(MENU_MANAGE);
const closeManageMenu = () => closeMenu(MENU_MANAGE);
const manageMenuOpen = state => state.scratchGui.menus[MENU_MANAGE];

export {
    reducer as default,
    initialState as menuInitialState,
    openAboutMenu,
    closeAboutMenu,
    aboutMenuOpen,
    openAccountMenu,
    closeAccountMenu,
    accountMenuOpen,
    openFileMenu,
    closeFileMenu,
    fileMenuOpen,
    openEditMenu,
    closeEditMenu,
    editMenuOpen,
    openLanguageMenu,
    closeLanguageMenu,
    languageMenuOpen,
    openLoginMenu,
    closeLoginMenu,
    loginMenuOpen,
    openSerialportMenu,
    closeSerialportMenu,
    serialportMenuOpen,
    openSettingMenu,
    closeSettingMenu,
    settingMenuOpen,
    openHelpMenu,
    closeHelpMenu,
    helpMenuOpen,
    openExtMenu,
    closeExtMenu,
    extMenuOpen,
    openManageMenu,
    closeManageMenu,
    manageMenuOpen
};
